module.exports = __webpack_public_path__ + "static/media/trackorder-on-the-way.1ccd2f16.png";